import { Injectable, Input, EventEmitter } from "@angular/core";
import { BaseService } from "./BaseService";
import { APIServiceConnector } from "./APIServiceConnector";
import { AppSettings } from "../Library/AppSettings";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { MasterDataService } from "./MasterDataService";
import { SessionChangeEvents } from "../Models/EnumModels";
import { UserService } from "./UserService";
import { QrCodeService } from "./QrCodeService";
import { DeviceService } from "./DeviceService";

@Injectable({
    providedIn: "root"
})
export class SessionsSignalRService extends BaseService {
    private _hubConnection: HubConnection;
    private _activeSessionId?: string;
    connectionEstablished = new EventEmitter<Boolean>();
    public connectionIsEstablished = false;
    SessionStateChanged = new EventEmitter();
    constructor(
        public apiService: APIServiceConnector,
        public masterService: MasterDataService,
        protected userService: UserService,
        public qrCodeService: QrCodeService,
        public deviceService: DeviceService
    ) {
        super();
    }

    public Init(): void {
        this.BaseURL = AppSettings.URL_Session;
        this.createConnection();
        this.registerOnServerEvents();
        this.startConnection();
    }

    private createConnection() {
        var objThis = this;
        this._activeSessionId = this.apiService.getSessionCookie();
        this._hubConnection = new HubConnectionBuilder()
            .withUrl(
                this.BaseURL +
                    "SessionHub?SessionId=" +
                    this._activeSessionId
        )
            .withAutomaticReconnect()
            .build();
    }

    private startConnection(): void {
        if (this._hubConnection == undefined || this._hubConnection == null) {
            this.createConnection();
        }

        this._hubConnection
            .start()
            .then(() => {
                this.connectionIsEstablished = true;
                //console.log('Hub connection started');
                this.connectionEstablished.emit(true);
            })
            .catch(err => {
                this.connectionIsEstablished = true;
                //console.log('Error while establishing connection, retrying...');
                if (!AppSettings.APP_DEBUG) {
                    window.setTimeout(() => { this.startConnection() }, 5000);
                }
            });


    }

    private registerOnServerEvents(): void {
        this._hubConnection.onclose(err => {
            this.connectionIsEstablished = false;
            this.connectionEstablished.emit(false);
            if (!AppSettings.APP_DEBUG) {
                window.setTimeout(() => { this.startConnection() }, 5000);
            }
        });

        this._hubConnection.on("Notify_SessionChange", (data: any) => {
            console.info(data);
            if (!data) {
                return;
            }

            this.SessionStateChanged.emit(data);
            if (data == SessionChangeEvents.Expire || data == SessionChangeEvents.DuplicateLogin) {
                alert("Your current session has expired.");
                this.apiService.signOutUser();
                return;
            }

        });

        this._hubConnection.on("Notify_UserQRCode", (data: any) => {
            if (data) {
                const expiryDate = (new Date).getTime() + AppSettings.IDTokenExpiry * 24 * 60 * 60 * 1000;
                console.info('SessionSignalR - QR Expiry - ', expiryDate);
                this.qrCodeService.setIdentifierToken(new Date(expiryDate));
                this.qrCodeService.startCookieThread();
                this.qrCodeService.redirectToHomeScreen();
            } else {
                console.info('SessionSignalR - NoApproval');
                this.qrCodeService.deleteIdentifierToken();
                this.qrCodeService.redirectToQrCode();
            }
        });

        this._hubConnection.on("Notify_DeActivateIdentifierTokenJobProgress", (data: any) => {
            this.deviceService.DeviceDeactivationProgress(data);
            console.log(data);
        });

        this.connectionEstablished.subscribe(data => {
            //console.info("C = " + data);
            if (data == true) this.RegisterUser();
        });
    }

    private RegisterUser(): void {
        //console.info(this.masterService.GetPropertyIDs());

        this._hubConnection.invoke("RegisterUser").then(data => {
            console.info(data);
        });
    }
}
